/* Evidence page: the waves selector and the two step explainers.
   Loaded by several ev-* sections, so it guards against running twice. */
(function () {
  if (window.__somaraEvidence) return;
  window.__somaraEvidence = true;

  var RM = window.matchMedia ? window.matchMedia("(prefers-reduced-motion: reduce)") : { matches: false };
  var NS = "http://www.w3.org/2000/svg";

  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }
  function watch(el, cb) {
    if (!("IntersectionObserver" in window)) { cb(true); return; }
    new IntersectionObserver(function (es) { es.forEach(function (e) { cb(e.isIntersecting); }); }, { threshold: 0.2 }).observe(el);
  }
  function onRM(cb) {
    if (RM.addEventListener) RM.addEventListener("change", cb);
    else if (RM.addListener) RM.addListener(cb);
  }

  /* ------------------------------------------------------------ steppers
     [data-ev-stepper] holds tabs [data-step] and scenes [data-scene]. The
     active tab's edge bar is a CSS animation lasting --dur; when it ends the
     next step plays. It only runs while on screen, not hovered or focused,
     not paused by the button, and not under reduced motion. */
  function stepper(root) {
    var tabs = [].slice.call(root.querySelectorAll("[data-step]"));
    var scenes = [].slice.call(root.querySelectorAll("[data-scene]"));
    var pause = root.querySelector("[data-ev-pause]");
    if (!tabs.length) return;
    var i = 0, userPaused = false, held = false, visible = false;

    function playing() { return !RM.matches && !userPaused && !held && visible; }
    function sync() {
      root.classList.toggle("is-paused", !playing());
      if (pause) {
        pause.classList.toggle("is-paused", userPaused);
        pause.setAttribute("aria-label", userPaused ? "Play the explainer" : "Pause the explainer");
      }
    }
    function set(n, focus) {
      i = (n + tabs.length) % tabs.length;
      tabs.forEach(function (t, k) {
        var on = k === i;
        t.classList.toggle("is-on", on);
        if (t.getAttribute("role") === "tab") { t.setAttribute("aria-selected", on); t.tabIndex = on ? 0 : -1; }
        else t.setAttribute("aria-pressed", on);
      });
      scenes.forEach(function (s, k) { s.classList.toggle("is-on", k === i); });
      /* restart the bar even when the same step is picked again */
      var bar = tabs[i].querySelector(".ev-mx-bar");
      if (bar) { bar.style.animation = "none"; void bar.offsetWidth; bar.style.animation = ""; }
      /* restart the scene's own animations */
      var sc = scenes[i];
      if (sc) { sc.classList.remove("is-on"); void sc.getBoundingClientRect(); sc.classList.add("is-on"); }
      if (focus) tabs[i].focus();
    }

    tabs.forEach(function (t, k) {
      var bar = t.querySelector(".ev-mx-bar");
      if (bar) bar.addEventListener("animationend", function () {
        if (t.classList.contains("is-on") && playing()) set(i + 1);
      });
      t.addEventListener("click", function () { set(k); });
      t.addEventListener("keydown", function (e) {
        var d = (e.key === "ArrowRight" || e.key === "ArrowDown") ? 1 : (e.key === "ArrowLeft" || e.key === "ArrowUp") ? -1 : 0;
        if (d) { e.preventDefault(); set(i + d, true); }
      });
    });
    root.addEventListener("mouseenter", function () { held = true; sync(); });
    root.addEventListener("mouseleave", function () { held = false; sync(); });
    /* keyboard focus pauses it; a mouse click leaves focus behind too, and
       that should not freeze the explainer until the next click elsewhere */
    root.addEventListener("focusin", function (e) {
      var kb = false;
      try { kb = e.target.matches(":focus-visible"); } catch (err) { kb = true; }
      if (kb) { held = true; sync(); }
    });
    root.addEventListener("focusout", function (e) { if (!root.contains(e.relatedTarget)) { held = false; sync(); } });
    if (pause) pause.addEventListener("click", function () { userPaused = !userPaused; sync(); });
    watch(root, function (v) { visible = v; sync(); });
    onRM(sync);
    set(0);
    sync();
  }

  /* ------------------------------------------------------------ waves
     One soft bump per finding, four nested lines each. The active bump
     becomes a travelling wave packet whose ripple length follows the
     wavelength its study used. Drawn into a 1200x300 viewBox stretched to the
     width of the stage. */
  function waves(root) {
    var svg = root.querySelector(".ev-wv-svg");
    var labs = [].slice.call(root.querySelectorAll(".ev-wv-lab"));
    var panels = [].slice.call(root.querySelectorAll(".ev-wv-panel"));
    var n = labs.length;
    if (!svg || !n) return;
    root.classList.add("is-js");

    var W = 1200, H = 300, Y0 = 282, SLOT = W / n;
    var HEIGHT = [1, 0.64, 0.88, 0.76, 0.68, 0.58, 0.82, 0.72];
    var dur = (parseFloat(root.getAttribute("data-dur")) || 6) * 1000;
    var items = labs.map(function (lab, k) {
      var g = document.createElementNS(NS, "g");
      g.setAttribute("class", "ev-wv-g");
      var paths = [0, 1, 2, 3].map(function () { var p = document.createElementNS(NS, "path"); g.appendChild(p); return p; });
      /* a wide invisible hit area so the whole bump is clickable */
      var hit = document.createElementNS(NS, "rect");
      hit.setAttribute("x", SLOT * k); hit.setAttribute("y", 0); hit.setAttribute("width", SLOT); hit.setAttribute("height", H);
      hit.setAttribute("fill", "transparent");
      g.appendChild(hit);
      g.addEventListener("click", function () { select(k, true); });
      svg.appendChild(g);
      lab.style.setProperty("--x", ((SLOT * (k + 0.5)) / W * 100).toFixed(3) + "%");
      return { g: g, paths: paths, cx: SLOT * (k + 0.5), amp: H * 0.72 * HEIGHT[k % HEIGHT.length],
               nm: parseFloat(lab.getAttribute("data-nm")) || 660, p: k === 0 ? 1 : 0, target: k === 0 ? 1 : 0 };
    });

    var active = 0, phase = 0, last = 0, raf = 0, timer = 0, visible = false, stopped = false, hover = false;
    function ease(t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; }

    function path(o, line) {
      /* drawn wider than its slot and tapered to the baseline at both ends: the
         selected wave widens, and clipped at the slot edge it used to stop in
         mid-air beside its neighbours */
      var pe = ease(o.p), half = SLOT * 0.8, N = 120;
      var sig = SLOT * 0.16 * (1 + 0.55 * pe);
      var amp = o.amp * [1, 0.86, 0.72, 0.58][line] * (1 + 0.14 * pe);
      var lam = SLOT * 0.2 * (o.nm / 660);
      var d = "";
      for (var j = 0; j <= N; j++) {
        var x = o.cx - half + (j / N) * 2 * half, dx = x - o.cx;
        var taper = Math.cos((Math.PI / 2) * (dx / half)); taper *= taper;
        var env = Math.exp(-(dx * dx) / (2 * sig * sig)) * taper;
        var carrier = 0.5 + 0.5 * Math.cos((2 * Math.PI * dx) / lam - phase - line * 0.55);
        var y = Y0 - amp * env * ((1 - pe) + pe * (0.22 + 0.78 * carrier));
        d += (j ? "L" : "M") + x.toFixed(1) + " " + y.toFixed(1);
      }
      return d;
    }
    function draw() {
      items.forEach(function (o, k) {
        o.paths.forEach(function (p, l) { p.setAttribute("d", path(o, l)); });
        o.g.classList.toggle("is-on", k === active);
        var peak = Y0 - o.amp * (1 + 0.14 * ease(o.p));
        labs[k].style.setProperty("--y", (peak / H * 100).toFixed(2) + "%");
      });
    }
    function running() { return visible && !RM.matches && document.visibilityState !== "hidden"; }
    function frame(ts) {
      var dt = Math.min(0.05, (ts - (last || ts)) / 1000);
      last = ts;
      phase += dt * 2.6;
      items.forEach(function (o) { o.p += (o.target - o.p) * Math.min(1, dt * 4.5); });
      draw();
      raf = running() ? requestAnimationFrame(frame) : 0;
      if (!raf) last = 0;
    }
    function kick() {
      if (RM.matches) { items.forEach(function (o) { o.p = o.target; }); draw(); return; }
      if (!raf && running()) raf = requestAnimationFrame(frame);
    }
    function schedule() {
      clearTimeout(timer);
      if (stopped || RM.matches || !visible) return;
      timer = setTimeout(function () { if (hover) schedule(); else select(active + 1, false); }, dur);
    }
    function select(k, byUser) {
      active = (k + n) % n;
      items.forEach(function (o, j) { o.target = j === active ? 1 : 0; });
      labs.forEach(function (l, j) {
        var on = j === active;
        l.classList.toggle("is-on", on);
        l.setAttribute("aria-selected", on);
        l.tabIndex = on ? 0 : -1;
      });
      panels.forEach(function (p, j) { p.classList.toggle("is-on", j === active); });
      if (byUser) { stopped = true; clearTimeout(timer); }
      schedule();
      kick();
    }

    labs.forEach(function (l, k) {
      l.addEventListener("click", function () { select(k, true); });
      l.addEventListener("keydown", function (e) {
        var d = (e.key === "ArrowRight") ? 1 : (e.key === "ArrowLeft") ? -1 : 0;
        if (d) { e.preventDefault(); select(active + d, true); labs[active].focus(); }
      });
    });
    var prev = root.querySelector("[data-wv-prev]"), next = root.querySelector("[data-wv-next]");
    if (prev) prev.addEventListener("click", function () { select(active - 1, true); });
    if (next) next.addEventListener("click", function () { select(active + 1, true); });
    var stage = root.querySelector(".ev-wv-stage");
    stage.addEventListener("mouseenter", function () { hover = true; });
    stage.addEventListener("mouseleave", function () { hover = false; });
    document.addEventListener("visibilitychange", kick);
    watch(root, function (v) { visible = v; schedule(); kick(); });
    onRM(function () { schedule(); kick(); });

    select(0, false);
    draw();
  }


  /* ------------------------------------------------------------ study explorer
     [data-ev-explorer] (snippets/ev-explorer): tabs pick a study panel; each
     [data-sx-chart] is drawn here with that study's published figures. A chart
     narrower than 480px is redrawn with labels above the bars so text stays at
     real size. On phones the tab row loops (rendered three times, the copies
     hidden from assistive tech) and drifts slowly until touched. */
  var SX_CHARTS = (function () {
    function svg(w, h, inner) { return '<svg class="ch" viewBox="0 0 ' + w + " " + h + '" role="img">' + inner + "</svg>"; }
    function t(x, y, s, cls, anchor) { return '<text x="' + x + '" y="' + y + '"' + (cls ? ' class="' + cls + '"' : "") + (anchor ? ' text-anchor="' + anchor + '"' : "") + ">" + s + "</text>"; }
    function legend(items) { return '<div class="ev-sx-legend">' + items.map(function (i) { return '<span><i style="' + i[0] + '"></i>' + i[1] + "</span>"; }).join("") + "</div>"; }
    var RED = "#B3271A", SHAM = "#CFC4B6", MUTE = "#6B6058", LINE = "#EAE1D2";
    return {
      jimenez: function (N) {
        var rows = [["Women · 9-beam", 20.2, 2.8, "p<0.0001"], ["Women · 12-beam", 20.6, 3.0, "p<0.0001"], ["Men · 7-beam", 18.4, 1.6, "p=0.0017"], ["Men · 9-beam", 20.9, 9.4, "p=0.0249"], ["Men · 12-beam", 25.7, 9.4, "p=0.0028"]];
        var W = N ? 340 : 560, L = N ? 0 : 118, R = W - (N ? 52 : 120), RH = N ? 60 : 46, TOP = N ? 16 : 0, h = "", H = rows.length * RH + TOP + 10;
        function sc(v) { return L + (R - L) * v / 28; }
        [0, 7, 14, 21, 28].forEach(function (v) { h += '<line x1="' + sc(v) + '" y1="' + (TOP + 4) + '" x2="' + sc(v) + '" y2="' + H + '" stroke="' + LINE + '"/>' + t(sc(v), H + 16, v, "", "middle"); });
        rows.forEach(function (r, i) {
          var y = TOP + 18 + i * RH;
          h += N ? t(0, y - 6, r[0]) + t(W, y - 6, r[3], "p", "end") : t(0, y + 15, r[0]) + t(W, y + 19, r[3], "p", "end");
          h += '<rect class="bar-anim" x="' + L + '" y="' + y + '" height="12" rx="6" width="' + (sc(r[1]) - L) + '" fill="' + RED + '" data-tip="' + r[0] + ": +" + r[1].toFixed(1) + " hairs/cm² with the laser comb vs +" + r[2].toFixed(1) + " with sham (" + r[3] + ')"/>' +
            '<rect class="bar-anim" x="' + L + '" y="' + (y + 15) + '" height="12" rx="6" width="' + (sc(r[2]) - L) + '" fill="' + SHAM + '"/>' +
            t(sc(r[1]) + 6, y + 11, "+" + r[1].toFixed(1), "vr") + t(sc(r[2]) + 6, y + 26, "+" + r[2].toFixed(1), "v");
        });
        return '<div class="ev-sx-ct"><b>Change in terminal hairs per cm² at 26 weeks</b></div>' + legend([["background:" + RED, "Laser comb"], ["background:" + SHAM, "Sham device"]]) + svg(W, H + 24, h) +
          '<div class="ev-sx-flow"><span><b>334</b> screened</span><em>→</em><span><b>269</b> randomised</span><em>→</em><span><b>44</b> lost to follow-up</span><em>→</em><span><b>225</b> analysed</span></div>' +
          '<p class="ev-sx-read"><b>How to read it:</b> every one of the five trial arms beat its sham, in men and women and with every comb model. The gain did not depend on age or sex. No serious adverse events.</p>';
      },
      lanzafame: function (N, m) {
        m = m || "pct";
        var D = {
          pct: { max: 70, rows: [["Sham", 11.05, "±48.30"], ["Active", 48.07, "±17.61"]], unit: "%", p: "p<0.001", sig: 1,
            read: "<b>How to read it:</b> the active group grew 48.1% more hair than at baseline; the sham group 11.1%. That 37-point gap is the headline figure. The wide spread in the sham group (±48.3) reflects a small, varied sample." },
          chg: { max: 160, rows: [["Sham", 23.9, "±30.1"], ["Active", 100.3, "±53.4"]], unit: " hairs", p: "p<0.0001", sig: 1,
            read: "<b>How to read it:</b> hairs gained in the masked 2.85cm² area. Active users gained about four times as many hairs as sham users." },
          abs: { max: 500, rows: [["Sham · before", 228.2, "±133.4"], ["Sham · after", 252.1, "±143.3"], ["Active · before", 209.6, "±118.5"], ["Active · after", 309.9, "±166.6"]], unit: "", p: "after: p=0.235", sig: 0,
            read: "<b>How to read it:</b> raw counts start and end with wide variation between people, so the after-treatment counts alone did not differ significantly (p=0.235). That is why the study measured change from each woman’s own baseline, its pre-set primary endpoint." }
        }[m];
        var W = N ? 340 : 560, L = N ? 0 : 90, R = W - (N ? 118 : 90), h = "", rh = N ? (D.rows.length > 2 ? 50 : 56) : (D.rows.length > 2 ? 34 : 46), top = N ? 16 : 0;
        function sc(v) { return L + (R - L) * v / D.max; }
        D.rows.forEach(function (r, i) {
          var y = top + 10 + i * rh, act = /Active/.test(r[0]);
          h += (N ? t(0, y - 6, r[0]) : t(0, y + 14, r[0])) + '<rect class="bar-anim" x="' + L + '" y="' + y + '" height="18" rx="9" width="' + (sc(r[1]) - L) + '" fill="' + (act ? RED : SHAM) + '"/>' + t(sc(r[1]) + 6, y + 14, r[1] + D.unit + "  " + r[2], act ? "vr" : "v");
        });
        var Hh = top + 10 + D.rows.length * rh;
        h += t(W, Hh + 8, D.p, D.sig ? "p" : "pn", "end");
        var seg = [["pct", "% increase"], ["chg", "Change"], ["abs", "Before and after"]].map(function (b) { return '<button type="button" aria-pressed="' + (b[0] === m) + '" data-m="' + b[0] + '">' + b[1] + "</button>"; }).join("");
        return '<div class="ev-sx-ct"><b>Hair counts, 16 weeks</b><div class="ev-sx-seg" role="group" aria-label="Measure">' + seg + "</div></div>" + svg(W, Hh + 16, h) + '<p class="ev-sx-read">' + D.read + "</p>";
      },
      forest: function (N) {
        var rows = [["Laser diodes alone", 1.52, 1.16, 1.88, true], ["All devices (overall)", 1.27, 0.993, 1.639, false], ["Laser diodes + LEDs", 0.85, 0.55, 1.16, false]];
        var W = N ? 340 : 560, L = N ? 8 : 168, R = W - (N ? 8 : 96), RH = N ? 64 : 54, H = rows.length * RH + 40, h = "";
        function sc(v) { return L + (R - L) * (v + 0.5) / 3; }
        [-0.5, 0, 0.5, 1, 1.5, 2, 2.5].forEach(function (v) { h += '<line x1="' + sc(v) + '" y1="8" x2="' + sc(v) + '" y2="' + (H - 30) + '" stroke="' + (v === 0 ? MUTE : LINE) + '"' + (v === 0 ? ' stroke-dasharray="4 4"' : "") + "/>" + t(sc(v), H - 12, v, "", "middle"); });
        h += t(sc(0) - 6, 22, "favours sham", "", "end") + t(sc(0) + 6, 22, "favours light →", "", "start");
        rows.forEach(function (r, i) {
          var y = (N ? 62 : 50) + i * RH, c = r[4] ? RED : MUTE, val = r[1].toFixed(2) + " [" + r[2] + "–" + r[3] + "]";
          h += N ? t(0, y - 16, r[0]) + t(W, y - 16, val, r[4] ? "vr" : "v", "end") : t(0, y + 4, r[0]) + t(W, y + 4, val, r[4] ? "vr" : "v", "end");
          h += '<line x1="' + sc(r[2]) + '" y1="' + y + '" x2="' + sc(r[3]) + '" y2="' + y + '" stroke="' + c + '" stroke-width="3" stroke-linecap="round"/>' +
            '<rect x="' + (sc(r[1]) - 7) + '" y="' + (y - 7) + '" width="14" height="14" fill="' + c + '" transform="rotate(45 ' + sc(r[1]) + " " + y + ')" data-tip="' + r[0] + ": SMD " + r[1] + " (95% CI " + r[2] + "–" + r[3] + ')"/>';
        });
        return '<div class="ev-sx-ct"><b>Effect on hair density vs sham (SMD, 95% CI)</b></div>' + svg(W, H + (N ? 12 : 0), h) +
          '<p class="ev-sx-read"><b>How to read it:</b> each diamond is the pooled effect and its line the 95% confidence interval. Anything right of the dashed zero line favours light. All three intervals sit clear of zero. Laser diodes alone outperformed laser diodes combined with LEDs (subgroup p=0.043).</p>';
      },
      waffle: function (N) {
        var W = N ? 340 : 560, gap = N ? 5 : 8, cw = Math.floor((W - 12 * gap) / 13), cells = "";
        for (var i = 0; i < 13; i++) {
          var col = i < 10 ? RED : i < 11 ? "#E2B1A8" : "#FFFFFF", lab = i < 10 ? "Significant improvement" : i < 11 ? "Improved, not significant" : "No statistics reported";
          cells += '<rect x="' + i * (cw + gap) + '" y="6" width="' + cw + '" height="' + cw + '" rx="' + Math.round(cw / 5) + '" fill="' + col + '" stroke="' + (i < 11 ? "none" : SHAM) + '" stroke-width="1.5" stroke-dasharray="' + (i >= 11 ? "4 3" : "0") + '" data-tip="Trial ' + (i + 1) + ": " + lab + '"/>';
        }
        return '<div class="ev-sx-ct"><b>13 clinical trials, one square each</b></div>' + svg(W, cw + 12, cells) +
          legend([["background:" + RED, "10 significant improvement"], ["background:#E2B1A8", "1 improved, not significant"], ["background:#fff;border:1.5px dashed " + SHAM, "2 no statistics; both showed marked improvement"]]) +
          '<p class="ev-sx-read"><b>How to read it:</b> of the 11 trials with statistical analysis, 10 found significant improvement against baseline or controls. Two trials showed benefit alongside topical minoxidil, and one alongside finasteride.</p>';
      },
      afifi: function (N) {
        var W = N ? 340 : 560, h = "";
        function sc(v) { return v / 680 * (W - 4); }
        h += '<rect x="0" y="8" width="' + sc(444) + '" height="26" rx="6" fill="#7A1C12" data-tip="444 men"/><rect x="' + (sc(444) + 4) + '" y="8" width="' + (sc(236) - 4) + '" height="26" rx="6" fill="#E2584A" data-tip="236 women"/>' +
          '<text x="10" y="26" style="fill:#F3EDE4;font-weight:700">444 men</text><text x="' + (sc(444) + 10) + '" y="26" style="fill:#FFFFFF;font-weight:700">236 women</text>';
        var rows = [["Hair count or density", 9, 11], ["Thickness and tensile strength", 2, 4]], RH = N ? 58 : 40, X0 = N ? 8 : 250, y0 = N ? 82 : 70;
        rows.forEach(function (r, i) {
          var y = y0 + i * RH;
          h += t(0, N ? y - 12 : y + 12, r[0]) + t(W, N ? y - 12 : y + 12, r[1] + " of " + r[2], "vr", "end");
          for (var k = 0; k < r[2]; k++) h += '<circle cx="' + (X0 + k * 24) + '" cy="' + (y + 8) + '" r="8" fill="' + (k < r[1] ? RED : LINE) + '" data-tip="' + r[0] + ": study " + (k + 1) + (k < r[1] ? ", significant improvement" : ", not significant") + '"/>';
        });
        return '<div class="ev-sx-ct"><b>680 patients across 11 studies</b></div>' + svg(W, y0 + rows.length * RH + (N ? 0 : 10), h) +
          '<p class="ev-sx-read"><b>How to read it:</b> nine of the eleven studies measuring hair count or density found statistically significant gains, in men and in women. Patient satisfaction, measured in five studies, was positive overall.</p>';
      }
    };
  })();

  function explorer(root) {
    var row = root.querySelector("[data-sx-tabs]");
    var real = [].slice.call(row.querySelectorAll(".ev-sx-tab"));
    var panels = [].slice.call(root.querySelectorAll("[data-panel]"));
    var n = real.length, cur = +root.getAttribute("data-first") || 0, loop = false;

    function draw(box) {
      var key = box.getAttribute("data-sx-chart"), f = SX_CHARTS[key];
      if (!f) return;
      var N = (box.clientWidth || box.parentNode.clientWidth || 600) < 480;
      box.setAttribute("data-narrow", N);
      box.innerHTML = f(N, box.getAttribute("data-m"));
      [].forEach.call(box.querySelectorAll(".ev-sx-seg button"), function (b) {
        b.addEventListener("click", function () { box.setAttribute("data-m", b.getAttribute("data-m")); draw(box); });
      });
    }
    function drawPanel(p) { [].forEach.call(p.querySelectorAll("[data-sx-chart]"), draw); }

    function select(i, focus) {
      cur = i;
      [].forEach.call(row.children, function (b) {
        var on = +b.getAttribute("data-i") === i;
        b.classList.toggle("is-on", on);
        if (b.hasAttribute("role")) { b.setAttribute("aria-selected", on); b.tabIndex = on ? 0 : -1; }
      });
      panels.forEach(function (p, j) { p.hidden = j !== i; });
      drawPanel(panels[i]);
      if (focus) real[i].focus();
    }
    real.forEach(function (b, i) {
      b.addEventListener("click", function () { select(i); });
      b.addEventListener("keydown", function (e) {
        var d = e.key === "ArrowRight" ? 1 : e.key === "ArrowLeft" ? -1 : 0;
        if (d) { e.preventDefault(); select((i + d + n) % n, true); }
      });
    });

    /* phone: endless row */
    function setW() { return row.children[n].offsetLeft - row.children[0].offsetLeft; }
    function makeLoop(on) {
      [].forEach.call(row.querySelectorAll("[data-copy]"), function (c) { c.remove(); });
      loop = on;
      if (!on) return;
      [true, false].forEach(function (before) {
        var frag = document.createDocumentFragment();
        real.forEach(function (b) {
          var c = b.cloneNode(true);
          c.removeAttribute("id"); c.removeAttribute("role"); c.removeAttribute("aria-controls"); c.removeAttribute("aria-selected");
          c.removeAttribute("data-shopify-editor-block");
          c.setAttribute("aria-hidden", "true"); c.setAttribute("data-copy", ""); c.tabIndex = -1;
          var i = +b.getAttribute("data-i");
          c.addEventListener("click", function () { select(i); });
          frag.appendChild(c);
        });
        if (before) row.insertBefore(frag, row.firstChild); else row.appendChild(frag);
      });
      row.scrollLeft = setW();
      setTimeout(function () { row.scrollLeft = setW(); }, 60);
    }
    var jumping = false;
    row.addEventListener("scroll", function () {
      if (!loop || jumping) return;
      var w = setW(), x = row.scrollLeft;
      if (x < w * 0.5 || x > w * 1.5) {
        jumping = true; row.style.scrollSnapType = "none"; row.scrollLeft = x < w * 0.5 ? x + w : x - w;
        setTimeout(function () { row.style.scrollSnapType = ""; jumping = false; }, 50);
      }
    }, { passive: true });

    /* phone: slow drift, paused by any touch for 3.5s, still under reduced motion */
    var idle = 0, seen = false, last = 0, acc = 0;
    function hold() { idle = performance.now() + 3500; row.style.scrollSnapType = ""; }
    ["pointerdown", "touchstart", "wheel", "focusin", "keydown"].forEach(function (ev) { row.addEventListener(ev, hold, { passive: true }); });
    watch(row, function (v) { seen = v; });
    setInterval(function () {
      var ts = performance.now(), dt = Math.min(0.05, (ts - (last || ts)) / 1000); last = ts;
      if (!loop || RM.matches || !seen || document.hidden || ts < idle) return;
      if (row.style.scrollSnapType !== "none") row.style.scrollSnapType = "none";
      acc += 28 * dt;
      if (acc >= 1) { var px = Math.floor(acc); acc -= px; row.scrollLeft += px; }
    }, 16);

    /* tooltips on chart marks */
    var tip = document.createElement("div"); tip.className = "ev-sx-tip"; tip.hidden = true; document.body.appendChild(tip);
    root.addEventListener("mousemove", function (e) {
      var el = e.target.closest && e.target.closest("[data-tip]");
      if (el) { tip.hidden = false; tip.textContent = el.getAttribute("data-tip"); tip.style.left = Math.min(e.clientX + 14, window.innerWidth - 250) + "px"; tip.style.top = (e.clientY + 14) + "px"; }
      else tip.hidden = true;
    });
    root.addEventListener("mouseleave", function () { tip.hidden = true; });

    var phone = window.innerWidth < 640;
    makeLoop(phone);
    select(cur);
    var rt = 0;
    window.addEventListener("resize", function () {
      clearTimeout(rt);
      rt = setTimeout(function () {
        var p = window.innerWidth < 640;
        if (p !== phone) { phone = p; makeLoop(p); select(cur); }
        else drawPanel(panels[cur]);
      }, 150);
    });
  }

  ready(function () {
    [].forEach.call(document.querySelectorAll("[data-ev-stepper]"), stepper);
    [].forEach.call(document.querySelectorAll("[data-ev-waves]"), waves);
    [].forEach.call(document.querySelectorAll("[data-ev-explorer]"), explorer);
  });
})();
